<template>
    <div class="relative">
        <input
            :id="inputId"
            :type="type"
            class="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent peer placeholder-transparent"
            :placeholder="label"
            v-model="inputValue"
            @focus="isFocused = true"
            @blur="isFocused = false"
            :min="min"
        />

        <label
            :for="inputId"
            class="absolute left-4 transition-all duration-200 ease-in-out pointer-events-none focus:text-primary"
            :class="labelClasses"
        >
            {{ label }}
        </label>
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    type: {
        type: String,
        default: 'text'
    },
    label: {
        type: String,
        default: 'IBAN *'
    },
    modelValue: {
        type: String,
        default: ''
    },
    inputId: {
        type: String,
        default: 'iban-input'
    },
    element: {
        type: String,
        default: 'input',
    },
    min: {
        type: String,
        default: ''
    },
})

const emit = defineEmits(['update:modelValue'])

const isFocused = ref(false)

const inputValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})

const labelClasses = computed(() => {
    const hasContent = inputValue.value !== null &&
        inputValue.value !== undefined &&
        inputValue.value !== '' &&
        String(inputValue.value).trim() !== ''
    const shouldFloat = isFocused.value || hasContent

    return {
        'top-3 text-gray-500 text-base': !shouldFloat,
        '-top-2 text-primary text-xs bg-white px-1': shouldFloat
    }
})
</script>